export const ROLES = {
    TENANT_ADMIN_ROLE: 'tenant_admin_role'
}